<script setup lang="ts">
import MenuCard from "@/views/restaurant/components/MenuCard.vue";
import MenuBlocItem from "@/views/restaurant/components/MenuBlocItem.vue";
import {defineProps} from 'vue'
const props = defineProps(
    {
      menuList:[],
      menuTitle:String,
    }
  )
</script>

<template>
  <!-- MENU BOOK -->
  <div id="impx-menu-carousel" class="impx-menu-carousel uk-padding uk-position-relative uk-padding-remove-horizontal mobile-rmv-pad vert uk-background-fixed uk-background-center-center uk-height-1-1">
    <div class="impx-overlay dark"></div>
    <div class="uk-container uk-container-large">

      <!-- Intro -->
      <div class="uk-grid uk-light">
        <div class="uk-width-xlarge-2-3 uk-width-large-2-3 uk-width-medium-3-4  uk-width-xlarge-1-1 uk-container-center impx-margin-top">
          <div class="impx-intro intro-light uk-text-center uk-contrast uk-position-relative uk-position-z-index" >
            <h2 class="uk-margin-remove">{{props.menuTitle??''}}</h2>
          </div>
        </div>
      </div>
      <!-- Intro End -->

      <!-- Menu groups -->
      <div class="uk-grid uk-flex uk-flex-center">
        <div class="uk-width-1-1">
          <menu-card >
            <menu-bloc-item
                v-for="(menu,index) in props.menuList" :key="index"
                :title="menu?.title"
                :desc="menu?.subtitle"
                :img-desc="menu?.menuImage?.url"
                :menu-list="menu.menus??[]"
            ></menu-bloc-item>
          </menu-card>
          <!-- Menu Carousel Group End -->
        </div>
      </div>
      <!-- Menu Carousel End -->
    </div>
  </div>
  <!-- MENU BOOK -->
</template>

<style scoped>

</style>